
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { TrendingDown, TrendingUp } from 'lucide-react';

export interface ArtistHealthMetricProps {
  title: string;
  value: number;
  icon: React.ReactNode;
  change?: number; // Made optional
  changeLabel?: string; // Made optional
  colorClass?: string;
}

const ArtistHealthMetric: React.FC<ArtistHealthMetricProps> = ({
  title,
  value,
  icon,
  change = 0, // Default value
  changeLabel = '', // Default value
  colorClass = 'bg-primary/10 text-primary border-primary/30'
}) => {
  const isPositive = change >= 0;
  
  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-full flex items-center justify-center bg-muted">
              {icon}
            </div>
            <h3 className="font-medium">{title}</h3>
          </div>
          {(change !== undefined || changeLabel) && (
            <Badge 
              variant="outline" 
              className={colorClass}
            >
              <span className="flex items-center gap-0.5">
                {isPositive ? (
                  <TrendingUp className="h-3 w-3" />
                ) : (
                  <TrendingDown className="h-3 w-3" />
                )}
                {Math.abs(change)}% {changeLabel}
              </span>
            </Badge>
          )}
        </div>
        <div className="text-2xl font-bold">{value}</div>
      </CardContent>
    </Card>
  );
};

export default ArtistHealthMetric;
